import { createApi } from '@reduxjs/toolkit/query/react'
import type { customQueries } from 'src/graphql/custom-queries'

import {
	fetchPaginatedListGraphqlApi,
	getSingularDataGraphqlApi,
} from 'src/utils/fetchGraphqlApi'

const graphqlBaseQuery =
	() =>
	async ({
		queryName,
		apiName,
		data,
		isList,
	}: {
		queryName: keyof typeof customQueries
		apiName?: string
		data: any
		isList: boolean
	}) => {
		try {
			let responseData
			if (isList) {
				responseData = await fetchPaginatedListGraphqlApi({
					queryName,
					apiName,
					data,
				})
			} else {
				responseData = await getSingularDataGraphqlApi({
					queryName,
					apiName,
					data,
				})
			}
			return { data: responseData }
		} catch (error) {
			return { error }
		}
	}

export const graphqlApi = createApi({
	reducerPath: 'graphqlApi',
	baseQuery: graphqlBaseQuery(),
	// Keep unused data in cache for 5 minutes
	keepUnusedDataFor: 300,
	tagTypes: [
		'Company',
		'Client',
		'Projects',
		'ProjectTotals',
		'PreparePurchase',
		'Quote',
		'QuoteTemplate',
		'BasicQuoteTemplate',
		'QuoteTotals',
		'QuoteInfo',
		'RecapInfo',
		'Suppliers',
		'UserInfo',
		'Freelancers',
		'FreelancerBilling',
		'Contact',
		'Comments',
		'SectionRename',
		'Currencies',
		'Purchase',
		'Proposals',
		'Invoice',
	],
	endpoints: () => ({}),
})
